<div #viewerContainer class="pdf-viewer">
  <main class="pdf-stage" aria-live="polite">
    <div *ngIf="loading" class="status-message">
      <span class="spinner" aria-hidden="true"></span>
    </div>

    <p *ngIf="!loading && errorMessage" class="error-message" role="alert">
      {{ errorMessage }}
    </p>

    <div
      *ngIf="!loading && !errorMessage && totalPages > 0"
      #pagesContainer
      class="pages-stack"
    ></div>
  </main>
</div>
